import { isUndefined } from 'lodash-es';

import { IndicatorsRenderer } from '../../../core/components/annotations/components/indicators/IndicatorsRenderer.js';
import { getUniqueIndicatorsByPriority } from '../../../core/components/annotations/components/indicators/utils/get-unique-indicators-by-priority.js';
import { getMinMaxAsNumber } from '../../../core/components/annotations/utils/get-min-max-as-number.js';
import { plotLayout } from '../../../core/components/chart-grid/ChartGrid.sty.js';
import { useAxesConfig } from '../../hooks/useAxesConfig.js';
import { useXYChartAnnotationsConfig } from '../../hooks/useXYChartAnnotationsConfig.js';
import { useXYChartAnnotationsShownIndicators } from '../../hooks/useXYChartAnnotationsShownIndicators.js';
import { useXYChartScales } from '../../hooks/useXYChartScales.js';
import { isAnyNumericalScale } from '../../types/guards.js';
import { getCurrentScale } from '../../utils/get-scale.js';

export const XYChartAnnotationsIndicators = () => {
  const indicators = useXYChartAnnotationsShownIndicators();
  const annotationsConfig = useXYChartAnnotationsConfig();
  const scales = useXYChartScales();
  const axes = useAxesConfig();
  const axisConfig = axes.find(
    (axis) => axis.id === annotationsConfig?.xAxisId,
  );

  if (isUndefined(annotationsConfig) || isUndefined(axisConfig)) {
    return;
  }

  const xScale = getCurrentScale(scales, axisConfig.id);
  const annotationsScale = {
    axisType: axisConfig.type,
    axisScale: xScale,
  };

  if (!isAnyNumericalScale(annotationsScale)) {
    return;
  }

  const [domainStart, domainEnd] = annotationsScale.axisScale.domain();
  const isInverted = domainStart > domainEnd;
  const { min: domainMin, max: domainMax } = getMinMaxAsNumber(
    domainStart,
    domainEnd,
  );

  const uniqueIndicators = getUniqueIndicatorsByPriority(
    [indicators],
    [domainMin, domainMax],
  );

  return (
    <svg className={plotLayout}>
      {uniqueIndicators.map((track, index) =>
        track.map(([key, indicator]) => (
          <IndicatorsRenderer
            key={key}
            {...indicator}
            trackIndex={index}
            scale={annotationsScale.axisScale}
            isInverted={isInverted}
          />
        )),
      )}
    </svg>
  );
};

XYChartAnnotationsIndicators['displayName'] = 'XyChartAnnotationsIndicators';
